export enum LineTypes {
  'SOLID' = 'solid',
  'DASHED' = 'dashed',
}
